import * as constants from 'actions/constants';


type Provider = 'apple.com' | 'google.com' | 'google.com redirect' | null;
// Define a more specific type for the User
export interface User {
  getIdToken: (forceRefresh?: boolean) => Promise<string>;
  stsTokenManager?: {
    accessToken: string;
    expirationTime: Date;
  };
  name?: string;
  uid: string;
  email: string;
  profileImage?: string;
  // Add other user properties as needed
}

export interface UserReducer {
  user: User | null;
  tokenExpired: boolean;
  token: string;
  tokenExpiration?: Date;
  lastRefresh: Date | null;
  tokenLoading: boolean;
  loginLoading: boolean;
  provider?: Provider
}

// Define the default state using the UserReducer interface
const defaultState: UserReducer = {
  user: null,
  tokenExpired: false,
  token: '',
  tokenExpiration: undefined,
  lastRefresh: null,
  tokenLoading: false,
  loginLoading: false,
};

export default function user(state = defaultState,
  action: { type: string; user?: User; name?: string; newAccessToken?: string; response?: any, provider?: Provider }) {
  switch (action.type) {
    case constants.LOGIN_ERROR:
      return defaultState;

    case constants.SET_NAME:
      return {
        ...state,
        user: {
          ...state.user,
          name: action.name,
        },
      };

    case constants.RESET_EXPIRATION:
      if (!state.user) return state; // If user is null, return current state
      return {
        ...state,
        user: {
          ...state.user,
          stsTokenManager: {
            ...state.user.stsTokenManager,
            expirationTime: new Date(),
          },
        },
        tokenExpired: false,
        provider: null
      };

    case constants.LOGIN_TRY:
      return {
        ...state,
        loginLoading: true,
        provider: action.provider
      };

    case constants.LOGIN_RESPONSE:
      return {
        ...state,
        user: action.user ? { ...action.user } : null,
        loginLoading: false,
        tokenExpired: !action.user,
        token: action.user?.stsTokenManager?.accessToken || '',
        tokenExpiration: action.user
          ? new Date(Date.now() + parseInt(process.env.TOKEN_EXPIRY as string) - 60000)
          : undefined,
        lastRefresh: action.user ? new Date() : null,
        provider: null
      };

    case constants.LOGOUT_RESPONSE:
      return defaultState;

    case constants.UPDATE_TOKEN_TRY:
      return {
        ...state,
        tokenLoading: true,
      };

    case constants.UPDATE_TOKEN_ERROR:
      return {
        ...state,
        tokenLoading: false,
      };

    case constants.UPDATE_TOKEN_RESPONSE:
      return {
        ...state,
        tokenLoading: false,
        user: action.user || state.user, // Keep current user if not provided
        token: action.newAccessToken || state.token,
        tokenExpiration: new Date(Date.now() + parseInt(process.env.TOKEN_EXPIRY as string) - 60000),
      };

    default:
      if (action?.response?.code === 'FORCE_LOGOUT_FRONTEND') return defaultState;
      if (action?.response?.code === 'TOKEN_EXPIRED') {
        return {
          ...state,
          tokenExpired: true,
        };
      }
      return state;
  }
}
